export default __webpack_public_path__ + "static/media/esurveybox-logo.8e86fee2.jpg";